import { FixMeLater } from 'types/FixMeLaterType';
import {
    DELETE_DASHBOARD_LAYOUT,
    GET_CURRENT_DASHBOARD_LAYOUT,
    GET_DASHBOARD_LAYOUTS,
    GET_DASHBOARD_LAYOUTS_BY_IDS,
    SET_DASHBOARD_LAYOUT,
    CLEAR_CURRENT_DASHBOARD_LAYOUT
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    dashboardLayouts: {},
    currentDashboardLayout: {}
};

interface DashboardLayout {
    id: string
}

// REDUCER
export const DashboardLayoutReducer = (state = initialState, action: FixMeLater) => {
    switch (action.type) {
        case GET_DASHBOARD_LAYOUTS:
        case GET_DASHBOARD_LAYOUTS_BY_IDS: {
            const incomingLayouts = action.payload;
            const newDashboardLayouts: { [index: string]: DashboardLayout  } = {};

            incomingLayouts.forEach((layout: DashboardLayout) => {
                newDashboardLayouts[layout.id] = layout;
            });

            return {
                ...state,
                dashboardLayouts: newDashboardLayouts
            }
        }

        case SET_DASHBOARD_LAYOUT: {
            const incomingLayout = action.payload;
            const newDashboardLayouts: { [index: string]: DashboardLayout  } = Object.assign({}, state.dashboardLayouts)
            var newCurrentDashboardLayouts = Object.assign({}, state.currentDashboardLayout)

            if (incomingLayout != null) {
                newDashboardLayouts[incomingLayout.id] = incomingLayout
                newCurrentDashboardLayouts = incomingLayout
            }

            return {
                ...state,
                dashboardLayouts: newDashboardLayouts,
                currentDashboardLayout: newCurrentDashboardLayouts
            }
        }

        case DELETE_DASHBOARD_LAYOUT: {
            const incomingLayoutId = action.payload;
            var newDashboardLayouts: { [index: string]: DashboardLayout  } = Object.assign({}, state.dashboardLayouts)

            delete newDashboardLayouts[incomingLayoutId]

            return {
                ...state,
                dashboardLayouts: newDashboardLayouts
            }
        }

        case GET_CURRENT_DASHBOARD_LAYOUT: {
            const incomingLayouts = action.payload;
            var incomingLayout = {}

            if (incomingLayouts.length > 0) {
                incomingLayout = incomingLayouts[0]
            }

            return {
                ...state,
                currentDashboardLayout: incomingLayout
            }
        }

        case CLEAR_CURRENT_DASHBOARD_LAYOUT: {
            return {
                ...state,
                currentDashboardLayout: {}
            }
        }

        default:
            return state;
    }
};